import { useMutationState } from '~/hooks/reactQuery/useMutationState';
import { useStoreActions } from '~/store/store-context';
export const useApproveAdHocInvoice = function useApproveAdHocInvoice() {
    let { onSuccess } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { api } = useStoreActions();
    const { mutate, isLoading, isError } = useMutationState({
        mutationFn: (param)=>{
            let { invoiceId, fundingSourceId } = param;
            return api.invoice.approveAdHoc({
                invoiceId,
                fundingSourceId
            });
        },
        onSuccess: ()=>{
            onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
        }
    });
    return {
        approveAdHocInvoice: mutate,
        isLoading,
        isError
    };
};
